/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Seating_PerfectInputs */



/**
* | output |
* | --- |
* | "Perfect" |
*
* @param {Rounds_Seating_PerfectInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_perfect = /** @type {((inputs?: Rounds_Seating_PerfectInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_PerfectInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parfait")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perfecto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Perfeito")
	if (locale === "it") return /** @type {LocalizedString} */ ("Perfetto")
	return /** @type {LocalizedString} */ ("Perfect")
});